import { axiosInstance } from "../axios/axiosConfig";
import { SHORTS_API } from "../constants/api-constants";

const SKIP_LOADING = { headers: { "X-Skip-Loading": true } };

export const getShorts = async (page = 1, pageSize = 10, seed, sort) => {
  const params = { page, pageSize };
  if (seed != null) params.seed = seed;
  if (sort) params.sort = sort;
  const res = await axiosInstance.get(SHORTS_API.BASE, { params, ...SKIP_LOADING });
  return res.data || { items: [], total: 0, page, pageSize };
};

export const getShortDetail = async (publicId) => {
  const res = await axiosInstance.get(`${SHORTS_API.BASE}/${publicId}`, SKIP_LOADING);
  return res.data;
};

export const incrementShortView = (publicId) =>
  axiosInstance.post(`${SHORTS_API.BASE}/${publicId}/view`, null, SKIP_LOADING).catch(() => {});

export const likeShort = async (publicId) => {
  const res = await axiosInstance.post(`${SHORTS_API.BASE}/${publicId}/like`, null, SKIP_LOADING);
  return res.data;
};

export const unlikeShort = async (publicId) => {
  const res = await axiosInstance.delete(`${SHORTS_API.BASE}/${publicId}/like`, SKIP_LOADING);
  return res.data;
};
